<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { computed } from 'vue'
import { useShop } from '@/composables/game/shop'
import { useMysteryBoxes } from '@/composables/game/mystery-boxes'
import DefaultBadge from '@/components/periodic/DefaultBadge.vue'
import type { BadgeVariant } from '@/components/periodic/DefaultBadge.vue'

const { canHaveSale } = useMysteryBoxes()
const { countdownForSaleEnds, isSale, isDefaultDiscount, isDefaultBOGO, isDefaultBOGX, isDefaultCashback, isIWD, isSTP } = useShop()

const hasSale = computed(() => canHaveSale.value && isSale.value)

const saleVariant = computed<BadgeVariant>(() => {
  if (isDefaultBOGO.value) return 'BOGO'
  if (isDefaultBOGX.value) return 'BOGX'
  if (isDefaultDiscount.value) return 'discount'
  if (isDefaultCashback.value) return 'cashback'
  if (isIWD.value) return 'IWD'
  if (isSTP.value) return 'STP'
  return 'discount' // fallback
})
</script>

<template>
  <HomeButton
    label="Mystery Box"
    :countdown="hasSale ? { value: countdownForSaleEnds, dangerThreshold: 3600 * 12 } : undefined"
  >
    <template #badge-top-left>
      <div
        v-if="hasSale"
        class="absolute -left-2.5 -top-2.5 size-[38px] z-[3]"
      >
        <DefaultBadge :variant="saleVariant" />
      </div>
    </template>
    <div class="flex items-center justify-center h-full w-full overflow-hidden rounded-[10px] relative">
      <img
        class="h-full w-auto object-cover z-[1] shadow-mystery-box"
        src="@/assets/images/mystery-boxes/mystery-boxes-button.webp"
      >
    </div>
  </HomeButton>
</template>
